import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RoleGuard = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  // Mobile detection for admin/operator role restriction
  const isMobile = () => {
    return window.innerWidth < 768; // md breakpoint
  };

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Redirect admin and operator roles on mobile devices
  if (isMobile() && (user.role === 'admin' || user.role === 'operator')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleGuard;